import Config from 'src/common/Config';

/**
 * Matches URLs on the configured API origin and nothing else. Anchored at both ends so trace
 * headers never leak to a third-party URL that merely contains the origin as a substring
 * (`https://evil.example/?next=<origin>`) or extends its hostname (`<origin>.evil.example`).
 * Deliberately avoids spelling out a real estate URL: sourcemaps embed this comment and the E2E
 * image build rejects any bundle that mentions production hosts.
 */
export function apiOriginPattern(): RegExp {
  const origin = new URL(Config.getApiUrl()).origin;
  return new RegExp(`^${origin.replace(/[.*+?^${}()|[\]\\]/g, '\\$&')}(?=[/?#]|$)`);
}
